import React from 'react'

import { SectionHeader, SectionHeaderContainerProps } from '../../components/SectionHeader'

import { LegalContainer } from './styled'
import Typography from '@mui/material/Typography'

export interface LegalProps {
  sectionHeaderProps?: SectionHeaderContainerProps
}
const currentHost = 'https://hutrewards.pizzahut.com'

export const Legal: React.FC<LegalProps> = ({
  sectionHeaderProps = { color: '#000', borderColor: '#cfcecc' },
}) => {
  return (
    <LegalContainer>
      <SectionHeader
        label=""
        color={sectionHeaderProps.color}
        borderColor={sectionHeaderProps.borderColor}
      />

      <Typography component="p">
        *Hut Rewards is open to US residents 18+ who have registered for the program. 
        Point earning (including delivery charges; taxes, tips, gift card purchases and donations are excluded) and redemption valid only for orders at participating stores. 
        Sign up and point redemption are available online only. Point minimums apply for redemption. Crust restrictions may apply. 
        Customer is responsible for all taxes, delivery charges and delivery minimums that may apply upon redemption. 
        Points have no cash value and may not be redeemed for cash. Pizza Hut reserves the right to cancel or change the program at any time. 
        Read full Hut Rewards Terms & conditions.
        <a href={`${currentHost}/terms`} target="_blank">
          &nbsp;Read full Hut Rewards Terms &amp; conditions
        </a>
      </Typography>
    </LegalContainer>
  )
}